import ValueProposition from './ValueProposition';
export default ValueProposition;
